import { render, staticRenderFns } from "./DigitalOrderEmail.vue?vue&type=template&id=9911264c&scoped=true"
import script from "./DigitalOrderEmail.vue?vue&type=script&lang=js"
export * from "./DigitalOrderEmail.vue?vue&type=script&lang=js"
import style0 from "./DigitalOrderEmail.vue?vue&type=style&index=0&id=9911264c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9911264c",
  null
  
)

export default component.exports